import { opportunitySchema } from "../config";
var OpportunityContextGenerator = /** @class */ (function () {
    function OpportunityContextGenerator() {
        var _this = this;
        this.buttonEnricher = function (event) {
            // button plugin maps data-sp-button-label to label in the event
            return _this.getContext(event.label);
        };
        this.linkEnricher = function (anchorElement) {
            // link plugin passes the entire anchor element rather than an event so we can access the dataset directly
            return _this.getContext(anchorElement.dataset.spButtonLabel);
        };
        this.getContext = function (label) {
            var _a;
            if (!label) {
                return null;
            }
            var parsedData;
            try {
                parsedData = JSON.parse(label);
            }
            catch (error) {
                return null;
            }
            var opportunity = (_a = parsedData.contexts) === null || _a === void 0 ? void 0 : _a.opportunity;
            if (!opportunity) {
                return null;
            }
            var opportunityData = {
                opportunity_id: opportunity.id,
                opportunity_origin: "tutor_request",
                opportunity_source: "memberships",
            };
            return {
                schema: opportunitySchema,
                data: opportunityData,
            };
        };
    }
    return OpportunityContextGenerator;
}());
export { OpportunityContextGenerator };
